const scaleValueToPercent = (min, max, val) => {
  if (max <= min) {
    throw new Error('scaleValueToPercent max value smaller or equal to min');
    // FIXME: Should this return 0 to prevent any templating errors?
  }
  return Math.round(100 * (val - min) / (max - min));
};

export default scaleValueToPercent;
